import React from 'react';
import { Table, TableRow, TableHead, TableCell, TableBody } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@material-ui/icons/Remove';
import { dateToLocal } from './Functions';

export function InfoTable({ rowData, columns, columnNames}) {

    return (
        <div className="table-background">
            <Table className="table-color">
                <TableHead>
                    <TableRow>
                        {columnNames.map((name, index) => (
                            <TableCell key={index}>{name}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rowData.map((data, indexRow) => (
                        <TableRow key={`r-${indexRow}`}>
                            {columns.map((column, indexColumn) => (
                                data[column] === true ?
                                (
                                    <TableCell key={`r-${indexRow}-c-${indexColumn}`}><CheckIcon /></TableCell>
                                ) :
                                data[column] === false ?
                                (
                                    <TableCell key={`r-${indexRow}-c-${indexColumn}`}><RemoveIcon /></TableCell>
                                ) :
                                column === "createdAt" || column === "modifiedAt" ?
                                (
                                    <TableCell key={`r-${indexRow}-c-${indexColumn}`}>{data[column] && dateToLocal(data[column]).toLocaleString()}</TableCell>
                                ) :
                                <TableCell key={`r-${indexRow}-c-${indexColumn}`}>{data[column]}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}